<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <!--    <div>-->
    <span class="title dialog-title">{{ 'event.guestSettings' | translate }}</span>
    <button mat-button class="mat-icon-button"
            (click)="dialogRef.close()"
            aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
    <!--    </div>-->
  </mat-toolbar>

  <div class="p-24 m-0 content">
    @if (disableAll) {
      <div class="has-participant-error">{{ 'has_participant_error_guest' | translate }}</div>
    }
    @for (rows of guestsRows; track rows) {
      <div>
        <div class="titles">
          {{ 'guestModal.' + rows.title | translate }}
          @if (rows.title !== 'free_text_title') {
            <input class="title-comment" id="{{rows.title}}" placeholder="{{'event.comment' | translate}}"
                   value="{{titleComments[rows.title]}}">
          }
        </div>
        @for (data of rows.row; track data) {
          <div
            [ngClass]="{'rows' : data.name !== 'term_and_condition' && data.name !== 'frame_condition_text_checkbox'
           && data.name !== 'free_text',
           'rows-vs-editor' : data.name === 'term_and_condition' || data.name === 'frame_condition_text_checkbox'
           || data.name === 'free_text'}">
            <mat-checkbox (change)="changeRows(data.id, $event)"
                          [checked]="data.checked" [disabled]="disableAll">{{ 'guestModal.' + data.name | translate }}
            </mat-checkbox>
            @if (textRows.indexOf(data.id) !== -1) {
              <mat-checkbox class='required-checkbox' (change)="changeRequired(data.id, $event)"
                            [disabled]="disableAll"
                            [checked]="chooseRequired.indexOf(data.id) !== -1">{{ 'required' | translate }}
              </mat-checkbox>
            }
            @if (data.name === 'term_and_condition') {
              <div>
                <quill-editor [(ngModel)]="terms"></quill-editor>
              </div>
            }
            @if (data.name === 'frame_condition_text_checkbox') {
              <div>
                <quill-editor [(ngModel)]="rules"></quill-editor>
              </div>
            }
            @if (data.name === 'free_text') {
              <div>
                <quill-editor [(ngModel)]="freeText"></quill-editor>
              </div>
            }
          </div>
        }
      </div>
    }
    <div class="titles">{{ 'guestModal.individual' | translate }}
      <span style="font-size: 14px; color: darkgray">{{ 'individuals_message' | translate }}</span>
      <input class="title-comment" id="individual" placeholder="{{'event.comment' | translate}}"
             value="{{titleComments?.individual}}">
    </div>
    @for (indiv of individualsCheckbox; let i = $index; track indiv) {
      <div class="individuals">
        <div class="individuals-header">
          <mat-form-field>
            <mat-label>{{ 'event.question_type' | translate }}</mat-label>
            <mat-select required style="color: black" [disabled]="indiv.approve"
                        [(ngModel)]="indiv.type">
              <mat-option [value]="'text'" style="color: black">
                {{ 'event.text' | translate }}
              </mat-option>
              <mat-option [value]="'checkbox'">
                {{ 'event.checkbox' | translate }}
              </mat-option>
              <mat-option [value]="'select'">
                {{ 'event.select' | translate }}
              </mat-option>
              <mat-option [value]="'radio'">
                {{ 'event.radio' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          @if (!disableAll) {
            <div>
              @if (!indiv.approve) {
                <mat-icon (click)="approveIndividual(indiv.id)" class="green">done</mat-icon>
              }
              @if (indiv.approve) {
                <mat-icon (click)="editIndividual(indiv.id)" class="orange">edit</mat-icon>
              }
              <mat-icon (click)="removeIndividual(indiv.id)" class="red">clear</mat-icon>
            </div>
          }
        </div>
        <mat-form-field class="title">
          <mat-label>{{ 'enter_title' | translate }}</mat-label>
          <input id="{{indiv.id}}" matInput [disabled]="indiv.approve" [(ngModel)]="indiv.value">
        </mat-form-field>
        @if (indiv.type === 'select' || indiv.type === 'radio') {
          <div class="answers">
            @for (answer of indiv.answers; track answer.id; let answerIndex = $index) {
              <div class="answer">
                <mat-form-field class="answer-title">
                  <mat-label>{{ 'event.enter_answer' | translate }}</mat-label>
                  <input id="{{indiv.id + '_' + answer.id}}" matInput [disabled]="indiv.approve" [value]="answer.title"
                         [(ngModel)]="answer.title">
                </mat-form-field>
                @if (!indiv.approve) {
                  <mat-icon (click)="removeIndividualAnswer(i, answerIndex)" class="red">clear</mat-icon>
                }
              </div>
            }
          </div>
          @if (!indiv.approve) {
            <button mat-raised-button (click)="addIndividualAnswers(i)">{{ 'event.addAnswer' | translate }}</button>
          }
        }
      </div>
    }
    @if (!disableAll) {
      <div>
        <mat-icon (click)="addIndividual()" class="blue">add</mat-icon>
      </div>
    }
  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      mat-raised-button
      (click)="saveChanges()"
      class="save-button mat-accent"
      [disabled]=""
      aria-label="SAVE">
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
